module.exports = __webpack_public_path__ + "static/media/share.8701c3c3.svg";